import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'



export default function reportForm() {


  const owners = ref([]);
  const contracts = ref([]);
  const groups = ref([]);
  const device_categories = ref([])
  const types = ref([]);

  ReportService.getDevicesOptions({
    type: 'group',
    user: store.state.auth.userData.id
  }).then(response => groups.value = response.data)



  ReportService.getDevicesOptions({
    type: 'user',
    user: store.state.auth.userData.id
  }).then(response => { owners.value = response.data })



  ReportService.getDevicesOptions({
    type: 'contract',
    user: store.state.auth.userData.id
  }).then(response => {
    // console.log("contracrs",response.data), W

    contracts.value = response.data
  })

  ReportService.getCategoriesFilterBy({
    type: 'device',
    user: store.state.auth.userData.id
  }).then(response => {


    //device_categories.value = response.data.categories.map((item)=>({id:item,name:item}))
    device_categories.value = response.data.categories;

  })


  ReportService.getTypesOptionsBy({
    category: 'COMPACTOR',

  }).then(response => { types.value = response.data })









  return {

    owners,
    contracts,
    groups,
    types,
    device_categories,
    // reFilterDevices

  }

}
